import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const Sex = (props) => {
  return (
    <FormGroup>
      <Col componentClass={ControlLabel} sm={5}>
        Sex *
      </Col>
      <Col sm={7}>
            <select
              className="custom-select"
              name="sex"
              onChange={props.handleChangeSex}
              value={props.sex}
              disabled={props.disabled}
              required={props.required}
            >
              <option value="">Please select</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
      </Col>
    </FormGroup>
  )
}

Sex.propTypes = {
  handleChangeSex: PropTypes.func,
  sex: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

Sex.defaultProps = {
  disabled: false,
  required: false
};

export default Sex;



// WEBPACK FOOTER //
// ./src/app/components/sex/Sex.js